module.exports = __webpack_public_path__ + "img/eae-uk-3.5ff250c9.jpg";